import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  clearStudentSurveyResults,
  requestStudentSurveyResults,
  receiveStudentSurveyResults,
  handleStudentSurveyResultsError,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_STUDENT_SURVEY_RESULTS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_STUDENT_SURVEY_RESULTS:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.STUDENT_SURVEY_RESULTS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.STUDENT_SURVEY_RESULTS_RESET:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
};

export const fetchGoSurveyResults = student_uuid => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestStudentSurveyResults());
  try {
    return fetch(
      `${
        API.student.survey_results
      }?chatgpt_response=true&student_uuid=${student_uuid}`,
      config
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveStudentSurveyResults(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentSurveyResultsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentSurveyResultsError(err));
  }
};

export const resetStudentSurveyResults = () => dispatch => {
  dispatch(clearStudentSurveyResults());
};
